import React from "react";
import { useState, useEffect } from "react";
import "./navbar.scss";
import { Link, useLocation } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";

const Navbar = () => {
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [show, setShow] = useState(false);

  const location = useLocation();

  return (
    <>
      <div className="navbar_layer">
        <section className="secondary-navbar">
          <div className="innner-navbar">
            <Link to="/"><img src="\assets\logonew.svg" /></Link>
            <div className="outer-side">
              <div className="inner-link">
                <Link to="/apps">
                  <a style={location.pathname === '/apps' ? { color: "#DAD9D9" } : {}}>Apps</a>
                </Link>
                <Link to="/builders">
                  <a style={location.pathname === '/builders' ? { color: "#DAD9D9" } : {}}>Builders</a>
                </Link>
                <Link to="/liquidity">
                  <a style={location.pathname === '/liquidity' ? { color: "#DAD9D9" } : {}}>Liquidity</a>
                </Link>
              </div>
              <Link to="/builders#program">
                <button>Start Building</button>
              </Link>
            </div>
          </div>
        </section>
        <div className="phonenav">
          <div className="inner_phonenav">
            <Link to="/">
              <img src="\assets\logonew.svg" />
            </Link>

            <img src="\assets\hamburger.svg" onClick={handleShow} />
          </div>
        </div>
      </div>
      <Offcanvas
        className="mobile-offcanvasdark"
        show={show}
        onHide={handleClose}
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            <div>
              <img src="\assets\logonew.svg" />
            </div>
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <div className="canvasnavv">
            <Link to="/apps">
              <div className="innner_canvas">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M9 3H4C3.44772 3 3 3.44772 3 4V9C3 9.55228 3.44772 10 4 10H9C9.55228 10 10 9.55228 10 9V4C10 3.44772 9.55228 3 9 3Z"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20 3H15C14.4477 3 14 3.44772 14 4V9C14 9.55228 14.4477 10 15 10H20C20.5523 10 21 9.55228 21 9V4C21 3.44772 20.5523 3 20 3Z"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M20 14H15C14.4477 14 14 14.4477 14 15V20C14 20.5523 14.4477 21 15 21H20C20.5523 21 21 20.5523 21 20V15C21 14.4477 20.5523 14 20 14Z"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M9 14H4C3.44772 14 3 14.4477 3 15V20C3 20.5523 3.44772 21 4 21H9C9.55228 21 10 20.5523 10 20V15C10 14.4477 9.55228 14 9 14Z"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <h2>Apps</h2>
              </div>
            </Link>
            <Link to="/builders#program" onClick={handleClose}>
              <div className="innner_canvas">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M18 16L22 12L18 8"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M6 8L2 12L6 16"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                  <path
                    d="M14.5 4L9.5 20"
                    stroke="#E6FF00"
                    stroke-width="1.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
                <h2>Builders</h2>
              </div>
            </Link>
            <Link to="/liquidity">
              <div className="innner_canvas">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7 16.3C9.2 16.3 11 14.47 11 12.25C11 11.09 10.43 9.99005 9.29 9.06005C8.15 8.13005 7.29 6.75005 7 5.30005C6.71 6.75005 5.86 8.14005 4.71 9.06005C3.56 9.98005 3 11.1 3 12.25C3 14.47 4.8 16.3 7 16.3Z" stroke="#E5FE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M12.5598 6.60002C13.2476 5.50114 13.7351 4.28906 13.9998 3.02002C14.4998 5.52002 15.9998 7.92002 17.9998 9.52002C19.9998 11.12 20.9998 13.02 20.9998 15.02C21.0056 16.4023 20.6007 17.7552 19.8366 18.9071C19.0726 20.059 17.9837 20.9582 16.708 21.4905C15.4323 22.0229 14.0273 22.1644 12.671 21.8973C11.3148 21.6302 10.0684 20.9664 9.08984 19.99" stroke="#E5FE00" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h2>Liquidity</h2>
              </div>
            </Link>

            <div className="rainbutton">
              <Link to="/builders#program" onClick={handleClose}><button>Start Building</button></Link>
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default Navbar;
